import { UserContext } from '@vp/ubik-fragment-types'

export const parseForcedFeatureGates = (raw: string | undefined): Set<string> => {
  if (!raw) {
    return new Set()
  }

  return new Set(raw.split(',').filter(Boolean))
}

export const isFeatureGateEnabled = (featureFlags: UserContext['featureFlags'], gate: string): boolean => {
  return featureFlags?.[gate] === 'true'
}
